import { useTranslation, Trans } from "react-i18next";

import at1 from '../../img/Ambassador/at1.png'
import at2 from '../../img/Ambassador/at2.png'
import at2mob from '../../img/Ambassador/at2mob.png'
import at3 from '../../img/Ambassador/at3.png'
import at4 from '../../img/Ambassador/at4.png'

function InvestMoney() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <p className="text-[20px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[600px] leading-[1.2]">
                <Trans>{t("ambassador.10")}</Trans>
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-[10px] mt-[20px] xl:hidden">
                <img src={at1} alt="" className="w-full h-full object-cover" />
                <img src={at2mob} alt="" className="w-full h-full object-cover md:hidden" />
                <img src={at2} alt="" className="w-full h-full object-cover hidden md:block" />
                <div className="grid grid-cols-2 sm:hidden gap-[10px]">
                    <img src={at3} alt="" className="w-full h-full object-cover" />
                    <img src={at4} alt="" className="w-full h-full object-cover" />
                </div>
                <img src={at3} alt="" className="w-full h-full object-cover hidden sm:block" />
                <img src={at4} alt="" className="w-full h-full object-cover hidden sm:block" />
            </div>
            <div className="hidden xl:flex gap-[20px] mt-[40px] w-full">
                <img src={at1} alt="" className="h-full w-full object-cover" />
                <img src={at2} alt="" className="h-full w-full object-cover"/>

                <div className="grid grid-cols-1 gap-[20px] w-full">
                    <img src={at3} alt="" className="h-full"/>
                    <img src={at4} alt="" className="h-full"/>
                </div>
            </div>
        </div>
    </div>

  );
}

export default InvestMoney;
  